import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate
import { fetchConToken } from '../api/fetch';
import { AuthContext } from '../auth/AuthContext';
import { useContextInfo } from '../context/ContextInfo';

export const useGetDta = (endpoint, payload = {}, method = 'GET') => {
    const [loading, setLoading] = useState(true);
    const { setResp } = useContextInfo();

    const [data, setData] = useState([]);
    const { logout } = useContext(AuthContext); // Obtén logout desde el contexto

    useEffect(() => {
        getInfo();
    }, []);

    const getInfo = async (point = endpoint, pay = payload, met = method) => {
        const resp = await fetchConToken(point, pay, met);
        if (resp.ok) {
            const { data } = resp;
            setData(data);
            setLoading(false);
        } else {
            setLoading(false);
            if (resp.msg) setResp(resp);
            if (resp?.logout) logout();
        }
    };

    return { loading, data, getInfo };
};
